import React from "react";
import styles from "./multiselect-dropdown.module.scss";
import { MultiSelect } from "react-multi-select-component";

export default function MultiSelectDropdown(props) {
    const { theme, options, placeholder, onChange, values, themeFilterState, checkThemeFilterState } = props;
    const [filteredValues, setFilteredValues] = React.useState(null);

    React.useEffect(() => {
        if (values) {
            const fv = values[theme.theme];
            setFilteredValues(fv);
        }
    }, [values, theme]);

    const valueRenderer = (selected, _options) => {
        // THIS IS UNNECESSARY (as they were all sharing state before)
        // rewrite - TO DO
        // for some reason, selected is being shared across all dropdowns
        // so we have to filter selected from the options for this theme.

        const optionLabels = _options.map(d => d.label);
        const selectedLabels = selected.map(d => d.label);

        const themeOptionsSelected = selectedLabels.filter(d => {
            // if the theme is not selected, don't display the number (unless none are selected at all)
            const subThemeIsSelected = optionLabels.includes(d);
            let themeIsSelected = true;

            if (themeFilterState) {
                themeIsSelected = checkThemeFilterState(theme.slug) || themeFilterState.length === 0;
            }

            return subThemeIsSelected || themeIsSelected;
        });

        // AND if there are sub-themes selected for other themes but not mine
        // then I should revert to 0
        // unless everything is zero man.

        const lengthToShow =
            selected.length === 0
                ? ` (${_options.length})`
                : themeOptionsSelected.length > 0
                ? `(${themeOptionsSelected.length})`
                : "";

        return `${theme.short} ${lengthToShow}`;
    };

    return (
        <React.Fragment>
            <span id={`label=${theme.slug}`} className={styles.multiSelectLabel}>
                Select this to see the sub-themes under {theme.theme}
            </span>
            <MultiSelect
                options={options}
                placeholder={placeholder}
                valueRenderer={valueRenderer}
                onChange={v => onChange(v, theme)}
                value={filteredValues ? filteredValues : []}
                hasSelectAll={false}
                disableSearch={true}
                labelledBy={`label=${theme.slug}`}
            />
        </React.Fragment>
    );
}
